// extracted by mini-css-extract-plugin
export default {"fed_container":"carasoul_fed_container__-7A47"};